import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IQuestionType } from "../../../Pages/QuestionType/IQuestionType";

export const ListDashboardPerformenceTrendSlice = createSlice({
  name: "ListDashboardPerformenceTrendSlice",
  initialState: {} as IReduxState<IQuestionType[]>,
  reducers: {
    listDashboardPerformenceTrend: (state) => {
      state.isLoading = true;
    },
    successlistDashboardPerformenceTrend: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistDashboardPerformenceTrend: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistDashboardPerformenceTrend,
  listDashboardPerformenceTrend,
  successlistDashboardPerformenceTrend,
} = ListDashboardPerformenceTrendSlice.actions;

export default ListDashboardPerformenceTrendSlice.reducer;
